export const LAYOUT_CONFIG = {
  headerHeight: 70,
  horizontalMenuHeight: 40,
  drawerWidth: 240,
  collapsedWidth: 70,
  backgroundColor: '#2a3042',
  transition: 'all 0.2s ease',
} as const;

export type LayoutMode = 'vertical' | 'horizontal';
